import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const AllProducts = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 10;

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const handleAddToCart = (product) => {
    if (!user) {
      alert("Please login to add products to cart");
      navigate("/account");
      return;
    }

    const cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];

    const existingProductIndex = cart.findIndex((p) => p.id === product._id);
    if (existingProductIndex !== -1) {
      cart[existingProductIndex].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
    navigate("/cart");
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/product/list`
        );
        if (response.data.success) {
          setProducts(response.data.products);
        } else {
          console.error("Error fetching products:", response.data.message);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(products.length / productsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <h4>Loading products...</h4>
      </div>
    );
  }

  return (
    <div style={{ padding: "50px 0", background: "#f8f9fa" }}>
      <div style={{ width: "100%", margin: "0 auto" }}>
        <div
          style={{
            background:
              "linear-gradient(to right, #56ab2f, #a8e063, #6bbf59, #9ce88f, #3a7d44)",
            padding: "40px 30px",
            borderRadius: "20px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
          </div>

          {products.length > 0 ? (
            <>
              {/* Product Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                  gap: "20px",
                }}
              >
                {currentProducts.map((product) => (
                  <div
                    key={product._id}
                    style={{
                      background: "white",
                      borderRadius: "16px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                      textAlign: "center",
                      padding: "20px 15px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <div
                      style={{
                        width: "160px",
                        height: "160px",
                        margin: "0 auto",
                        overflow: "hidden",
                        borderRadius: "12px",
                      }}
                    >
                      <Link to={`/product-details/${product._id}`}>
                        <img
                          src={
                            product.image?.[0] ||
                            "/assets/images/thumbs/placeholder.jpg"
                          }
                          alt={product.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            transition: "transform 0.3s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.15)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </Link>
                    </div>

                    <div style={{ marginTop: "15px" }}>
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#333",
                          lineHeight: "1.3",
                          marginBottom: "6px",
                        }}
                      >
                        <Link
                          to={`/product-details/${product._id}`}
                          style={{ color: "#333", textDecoration: "none" }}
                        >
                          {product.name}
                        </Link>
                      </p>

                      <p
                        style={{
                          color: "#2b9348",
                          fontWeight: "700",
                          margin: "4px 0",
                        }}
                      >
                        ₹{product.offerPrice || product.price}
                        <span
                          style={{
                            color: "#777",
                            fontSize: "13px",
                            marginLeft: "5px",
                          }}
                        >
                          / {product.unit || "unit"}
                        </span>
                      </p>

                      <div
                        style={{
                          background: "#f4f7f6",
                          borderRadius: "10px",
                          padding: "8px 10px",
                          marginTop: "8px",
                          fontSize: "13px",
                          textAlign: "left",
                        }}
                      >
                        <p style={{ margin: 0, color: "#333" }}>
                          👤 Seller:{" "}
                          <span style={{ fontWeight: "600" }}>
                            {product.seller?.name || "Unknown"}
                          </span>
                        </p>
                        <p style={{ margin: "3px 0", color: "#555" }}>
                          📦 Stock:{" "}
                          <span
                            style={{
                              color:
                                product.stock < 10 ? "#d9534f" : "#2b9348",
                              fontWeight: "600",
                            }}
                          >
                            {product.stock || 0} left
                          </span>
                        </p>
                      </div>

                      <button
                        onClick={() => handleAddToCart(product)}
                        style={{
                          background:
                            "linear-gradient(90deg, #3bb77e, #2eb872)",
                          border: "none",
                          color: "white",
                          padding: "8px 20px",
                          borderRadius: "20px",
                          cursor: "pointer",
                          fontWeight: "600",
                          marginTop: "12px",
                        }}
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor:
                      currentPage === 1 ? "#ccc" : "#3bb77e",
                    color: "white",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    fontWeight: "600",
                  }}
                >
                  Prev
                </button>

                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => handlePageChange(i + 1)}
                    style={{
                      padding: "8px 14px",
                      borderRadius: "8px",
                      border: "none",
                      backgroundColor:
                        currentPage === i + 1 ? "#2eb872" : "#3bb77e",
                      color: "white",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "8px",
                    border: "none",
                    backgroundColor:
                      currentPage === totalPages ? "#ccc" : "#3bb77e",
                    color: "white",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    fontWeight: "600",
                  }}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <div className="text-center">
              <h5>No products available</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllProducts;
